import DataTablePage from 'components/DataTablePage';
import MDButton from 'components/MDButton';
import { Navigate, useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogActions } from '@mui/material';
import { Can } from 'context';
import { useState } from 'react';
import operatorColumnData from 'data/operatorColumnData';
import { deleteOperator, getOperators } from 'services/operators';
import usePersistedFilters from 'hooks/usePersistedFilters';

function OperatorManagement() {
  const navigate = useNavigate();
  const { setEntityFiltersForNavigation } = usePersistedFilters();
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [deleteOperatorId, setDeleteOperatorId] = useState('');
  const [filters, setFilters] = useState('');

  const handleViewDashboard = (operator) => {
    setEntityFiltersForNavigation({
      clientIds: operator.client?.id ? [operator.client.id] : [],
      clientNames: operator.client?.name ? [operator.client.name] : [],
      operatorIds: [operator.id],
      operatorNames: [operator.name]
    });
    navigate('/dashboard');
  };

  return (
    <>
      <Can I='read' a='operator'>
        <DataTablePage
          title='Operator Management'
          createButton={
            <Can I='create' a='operator'>
              <MDButton variant='contained' color='info' onClick={() => navigate('/operator-management/new-operator')}>
                Add Operator
              </MDButton>
            </Can>
          }
          canSearch
          canFilter
          fetchData={getOperators}
          queryKey='operators'
          columnData={operatorColumnData}
          object={'operator'}
          onDelete={(id) => {
            setDeleteOperatorId(id);
            handleOpenModal();
          }}
          onView={handleViewDashboard}
          filters={filters}
        />
        <Dialog
          open={showModal}
          onClose={handleCloseModal}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'Are you sure you want to delete this operator?'}</DialogTitle>
          <DialogActions>
            <MDButton
              onClick={async () => {
                await deleteOperator(deleteOperatorId);
                handleCloseModal();
                setFilters(filters.length ? '' : 'd');
              }}
            >
              Yes
            </MDButton>
            <MDButton onClick={handleCloseModal}>No</MDButton>
          </DialogActions>
        </Dialog>
      </Can>
      <Can not I='read' a='operator'>
        <Navigate to='/dashboard' replace />
      </Can>
    </>
  );
}

export default OperatorManagement;
